module.exports = __webpack_public_path__ + "img/ga.128a1ddd.svg";